/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = { RELEASE_20220725_SECUREMESSAGING_BLOCK3_TEXT: 'notifications.release.20220725.secureMessaging.block3.text' };

const enMessages = { [IDS.RELEASE_20220725_SECUREMESSAGING_BLOCK3_TEXT]: '. Please include your loan number in the subject line. Thank you!' };

const enMurabahaMessages = {
  ...enMessages,
  [IDS.RELEASE_20220725_SECUREMESSAGING_BLOCK3_TEXT]: '. Please include your account number in the subject line. Thank you!',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
